var install = {
  install: function install(Vue, options) {
    var prefix = options.prefix ? options.prefix : '';
    var $localStorage = {
      setItem: function setItem(key, value) {
        return localStorage.setItem("" + prefix + key, value || '');
      },
      getItem: function getItem(key) {
        return localStorage.getItem("" + prefix + key);
      }
    };
    Vue.prototype.$localStorage = $localStorage;
    Vue.mixin({
      created: function created() {
        Vue.prototype.$dataStatistics = Vue.prototype.$dataStatistics;
      }
    });
  }
};
export default install;